import { makeModule } from '@codium/codium-vue'
import { storeModule as mediaOwnerTags } from './lists/media-owner-tags'
import { storeModule as screenTags } from './lists/screen-tags'
import { storeModule as mediaOwnerScreenTags } from './lists/media-owner-screen-tags'
import { storeModule as mediaOwners } from './lists/media-owners'
import { storeModule as screens } from './lists/screens'
import { storeModule as energyProviders } from './lists/energy-providers'

export const storeModule = makeModule('lists', {
  modules: {
    mediaOwnerTags,
    screenTags,
    mediaOwnerScreenTags,
    mediaOwners,
    screens,
    energyProviders
  }
})
